export const fetchCardBrands = () => ({
  type: 'FETCH_CARD_BRANDS',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: '/v1/configurations/cardBrands'
    }
  }
})

export default {
  fetchCardBrands
}



// WEBPACK FOOTER //
// ./src/features/CardBrands/actions.js